import { DefaultButton, Fabric, TextField } from 'office-ui-fabric-react';
import PropTypes from 'prop-types';
import React from 'react';
import './Options.css';

class Options extends React.Component {
  static propTypes = {
    apiKey: PropTypes.string,
    onSubmit: PropTypes.func.isRequired
  };

  render() {
    let apiKey;

    return (
      <Fabric>
        <form
          onSubmit={e => {
            e.preventDefault();
            if (!apiKey.value.trim()) {
              return;
            }
            this.props.onSubmit(apiKey.value);
          }}
          className="options-form"
        >
          <TextField label="API Key" value={this.props.apiKey} ref={node => (apiKey = node)} />
          <DefaultButton primary={true} text="Submit" type="submit" />
        </form>
      </Fabric>
    );
  }
}

export default Options;



// WEBPACK FOOTER //
// ./src/components/Options/Options.js